<div class="multi-select-dropdown" appClickedOutside (clickOutside)="closeDropdown()">
    <div class="dropdown-trigger" [ngClass]="{'is-invalid':isSubmitted && selectItems && selectItems.length == 0}"
        [class.open]="isDropdownOpen" (click)="toggleDropdown()" tabindex="0">
        <span class="dropdown-display">
            @if (selectItems?.length) {
            <div class="chips">
                @for(item of selectItems?.controls | slice:0: newCreation ? 1 : 3; track $index){
                <span>
                    {{item.value.name}}
                    <i (click)="removeItemFromArray($index)">×</i>
                </span>
                }
                @if(selectItems && selectItems.length > (newCreation ? 1 : 3)){
                <span class="more">
                    +{{selectItems && selectItems.length - (newCreation ? 1 : 3) }} more
                </span>
                }

            </div>
            } @else {
            <span class="dropdown-placeholder">Select {{title}}</span>
            }
        </span>
    </div>

    @if (isDropdownOpen) {
    <div class="dropdown-content" (click)="$event.stopPropagation()">
        <div class="dropdown-search">
            <input type="text" class="search-input" [placeholder]="'Search By ' + title" [(ngModel)]="searchTerm"
                (input)="onSearch($event)">
            <div class="search-icon">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                </svg>
            </div>
        </div>
        @if(newCreation){
        @if(!showCustomCateogory){
        <div class="add-new" (click)="addNewCustomCategory()">
            <img [src]="addNew" alt="addNew" />
            <div>Add New</div>
        </div>
        }
        @if(showCustomCateogory){
        <div class="custom-category">
            <input type="text" class="search-input" [placeholder]="'Enter custom category'"
                [(ngModel)]="customCategory">
            <div class='img-div'>
                <img [src]="tick" alt="tick" (click)="saveCustomCategories()" />
                <img [src]="cross" alt="cross" (click)="closeCustomCategory()" />
            </div>
        </div>
        }
        }
        @if(selectAll){
        <div class="select-all">
            <label class="checkbox-label" [ngClass]="{'custom-width': customWidth() }">
                <input type="checkbox" [checked]="isAllChecked()" (change)="onSelectAllChanged($event)">
                <span class="checkbox-custom"></span>
                <span class="option-text">Select All</span>
            </label>
            <label class="danger" (click)="onClearAll()">Clear All</label>

        </div>
        }


        <div class="dropdown-options">
            @for (option of getFilteredOptions(); track option.value) {
                <div class="option-item" [class.has-children]="option.children">
                    <div class="option-content">
                        <label [class]="'checkbox-label'">
                            <input type="checkbox" (change)="onItemChanged($event,option)" [value]="option.value"
                                [checked]="isChecked(option.name)">
                            <span class="checkbox-custom"></span>
                            <span class="option-text">{{ option.name }}</span>
                        </label>
                    </div>
                </div>
            }
            @if (getFilteredOptions().length === 0) {
            <div class="no-options">
                No {{title}} found
            </div>
            }
        </div>
    </div>
    }

    @if(isSubmitted && selectItems && selectItems.length == 0){
    <div class="invalid-feedback">
        <div>Please select at least one {{title.toLocaleLowerCase()}}</div>
    </div>
    }
</div>